import { PRESUPUESTADOR_CLEAR_PAYMENTS_METHODS } from './constants'

export function clearPaymentsMethods() {
  return {
    type: PRESUPUESTADOR_CLEAR_PAYMENTS_METHODS,
  }
}

export function reducer(state, action) {
  if (action.type === PRESUPUESTADOR_CLEAR_PAYMENTS_METHODS) {
    return {
      ...state,
      payments_methods: [],
    }
  } else {
    return state
  }
}
